import { fetchFulfillmentCatalogStats } from '@entities/fulfillment/index.server'
import { LandingFigureRow, type LandingFigure } from '@ui/landing'
import { pluralize } from '@utils/formaters'

const numberFormat = new Intl.NumberFormat('ru-RU')
const fulfillmentForms = ['фулфилмент', 'фулфилмента', 'фулфилментов']
const cityForms = ['город', 'города', 'городов']

/**
 * Показатель про каталог. Пока карточек нет, счётчик не показываем: строка «0 фулфилментов»
 * отговаривает размещаться сильнее, чем её отсутствие — честнее сказать, что каталог только
 * открылся и верх выдачи ещё свободен. Если же число не пришло совсем, вместо него идёт факт о
 * размещении: утверждать «каталог только открылся», когда в нём сотня карточек, а сервер молчит,
 * значит вводить в заблуждение.
 */
const toCatalogFigure = (fulfillmentCount: number | null): LandingFigure => {
  if (fulfillmentCount === null) {
    return { label: 'Договор', value: 'Не нужен', note: 'и платы за размещение тоже нет' }
  }

  if (fulfillmentCount === 0) {
    return { label: 'Каталог', value: 'Открылся', note: 'верх выдачи ещё свободен' }
  }

  return {
    label: 'Уже в каталоге',
    value: numberFormat.format(fulfillmentCount),
    note: pluralize(fulfillmentCount, fulfillmentForms),
  }
}

/** Показатель про города складов. Нет числа — показываем бесплатность: она от сервера не зависит. */
const toGeographyFigure = (cityCount: number | null): LandingFigure => {
  if (cityCount === null || cityCount === 0) {
    return { label: 'Размещение', value: '0 ₽', note: 'и заявки тоже бесплатны' }
  }

  return { label: 'География', value: numberFormat.format(cityCount), note: pluralize(cityCount, cityForms) }
}

/** Живые числа каталога под первым экраном. */
export const CatalogNumbers = async () => {
  const { cityCount, fulfillmentCount } = await fetchFulfillmentCatalogStats()

  return (
    <LandingFigureRow
      items={[
        // В колонке цифр то же число записано короче: «более 100 000» встаёт в две строки и ломает ряд.
        { label: 'Продавцов в Evirma', value: '100 000+', note: 'сайт и расширение' },
        toCatalogFigure(fulfillmentCount),
        toGeographyFigure(cityCount),
      ]}
    />
  )
}
